import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_c8yganb0qb: FaireBrandEntity = {
  token: "b_c8yganb0qb",
  type: "brand",
  name: "RicebyRice",
  avatarUrl:
    "https://cdn.faire.com/fastly/070cfede04f333cba965617aea6aa6f5bd9b95cec7a073b666d3303463bc2cde.png",
  logoUrl:
    "https://cdn.faire.com/fastly/070cfede04f333cba965617aea6aa6f5bd9b95cec7a073b666d3303463bc2cde.png",
  minimumOrderDollars: 100,
  rating: 4.7,
  reviewCount: 14,
  meta: {
    source: "api",
    importedAt: "2026-04-06T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
